import { rem } from '@vimeo/bokeh-utils';

const parts = ["root", "input"];
const baseStyle = {
  root: {
    width: "100%",
    minHeight: "5rem",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "lg",
    border: rem(3),
    borderStyle: "solid",
    borderColor: "rgb(238, 241, 244)",
    willChange: "transform",
    transition: "background 100ms ease-in-out",
    '&[data-isdragging="true"]': {
      borderStyle: "dashed",
      borderColor: "rgba(0, 173, 239, 0.5)",
      background: "rgba(0, 173, 239, 0.2)"
    },
    _dark: {
      borderColor: "rgb(35, 49, 59)",
      '&[data-isdragging="true"]': {
        borderStyle: "dashed",
        borderColor: "rgba(0, 173, 239, 0.5)",
        background: "rgba(0, 173, 239, 0.2)"
      }
    }
  },
  input: {
    display: "none"
  }
};
const Dropzone = { parts, baseStyle };

export { Dropzone };
